import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../Animations/Loader";

function LogoutPageComponent() {
    const navigate = useNavigate();

    useEffect(() => {
        const logout = async () => {
            const token = sessionStorage.getItem("token");

            try {
                await fetch(`${process.env.REACT_APP_BASE_URL}cc/logout`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                });
            } catch (error) {
                console.error("Logout API call failed:", error);
            }

            sessionStorage.clear();
            localStorage.clear();
            setTimeout(() => {
                navigate("/login");
            }, 300);
            // navigate("/login");
        };

        logout();
    }, []);

    return <Loader />;
}

export default LogoutPageComponent;
